export default "__VITE_ASSET__CPazP4nN__"